import {metadaApi} from '@dms/api/base';

import {
  DeleteSelectableMaterialItemRequest,
  DeleteSelectableMaterialItemRequestSchema,
  DeleteSelectableMaterialItemResponse,
  DeleteSelectableMaterialItemResponseSchema,
  DeleteSelectableMaterialRequest,
  DeleteSelectableMaterialRequestSchema,
  DeleteSelectableMaterialResponse,
  DeleteSelectableMaterialResponseSchema,
  GetSelectableMaterialItemResponse,
  GetSelectableMaterialItemResponseSchema,
  GetSelectableMaterialItemsRequest,
  GetSelectableMaterialItemsRequestSchema,
  GetSelectableMaterialRequest,
  GetSelectableMaterialRequestSchema,
  GetSelectableMaterialResponse,
  GetSelectableMaterialResponseSchema,
  PatchSelectableMaterialItemRequest,
  PatchSelectableMaterialItemRequestSchema,
  PatchSelectableMaterialItemResponse,
  PatchSelectableMaterialItemResponseSchema,
  PostSelectableMaterialItemPairRequest,
  PostSelectableMaterialItemPairRequestSchema,
  PostSelectableMaterialItemPairResponse,
  PostSelectableMaterialItemPairResponseSchema,
  PostSelectableMaterialItemRequest,
  PostSelectableMaterialItemRequestSchema,
  PostSelectableMaterialItemResponse,
  PostSelectableMaterialItemResponseSchema,
  PostSelectableMaterialItemUnpairRequest,
  PostSelectableMaterialItemUnpairRequestSchema,
  PostSelectableMaterialItemUnpairResponse,
  PostSelectableMaterialItemUnpairResponseSchema,
  PostSelectableMaterialRequest,
  PostSelectableMaterialRequestSchema,
  PostSelectableMaterialResponse,
  PostSelectableMaterialResponseSchema,
} from './types';

export const metadaSelectableMaterial = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getSelectableMaterial: build.query<GetSelectableMaterialResponse, GetSelectableMaterialRequest>(
      {
        query: (queryArg) => ({
          url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}`,
          method: 'GET',
          queryArg,
        }),
        providesTags: (result, error, queryArg) => [
          {type: 'selectableMaterial', id: queryArg.selectableMaterialId},
        ],
        extraOptions: {
          responseSchema: GetSelectableMaterialResponseSchema,
          requestSchema: GetSelectableMaterialRequestSchema,
        },
      }
    ),
    postSelectableMaterial: build.mutation<
      PostSelectableMaterialResponse,
      PostSelectableMaterialRequest
    >({
      query: (queryArg) => ({
        url: '/service/v1/selectable-material',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'selectableMaterial', id: result?.selectableMaterialId},
      ],
      extraOptions: {
        responseSchema: PostSelectableMaterialResponseSchema,
        requestSchema: PostSelectableMaterialRequestSchema,
      },
    }),
    deleteSelectableMaterial: build.mutation<
      DeleteSelectableMaterialResponse,
      DeleteSelectableMaterialRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'selectableMaterial', id: queryArg.selectableMaterialId},
      ],
      extraOptions: {
        responseSchema: DeleteSelectableMaterialResponseSchema,
        requestSchema: DeleteSelectableMaterialRequestSchema,
      },
    }),
    getSelectableMaterialItem: build.query<
      GetSelectableMaterialItemResponse,
      GetSelectableMaterialItemsRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}/item/${queryArg.selectableMaterialItemId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'selectableMaterialItem', id: queryArg.selectableMaterialItemId},
      ],
      extraOptions: {
        responseSchema: GetSelectableMaterialItemResponseSchema,
        requestSchema: GetSelectableMaterialItemsRequestSchema,
      },
    }),
    postSelectableMaterialItem: build.mutation<
      PostSelectableMaterialItemResponse,
      PostSelectableMaterialItemRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}/item`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'selectableMaterial', id: queryArg.selectableMaterialId},
      ],
      extraOptions: {
        responseSchema: PostSelectableMaterialItemResponseSchema,
        requestSchema: PostSelectableMaterialItemRequestSchema,
      },
    }),
    patchSelectableMaterialItem: build.mutation<
      PatchSelectableMaterialItemResponse,
      PatchSelectableMaterialItemRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}/item/${queryArg.selectableMaterialItemId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'selectableMaterialItem', id: queryArg.selectableMaterialItemId},
      ],
      extraOptions: {
        responseSchema: PatchSelectableMaterialItemResponseSchema,
        requestSchema: PatchSelectableMaterialItemRequestSchema,
      },
    }),
    deleteSelectableMaterialItem: build.mutation<
      DeleteSelectableMaterialItemResponse,
      DeleteSelectableMaterialItemRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}/items/delete`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'selectableMaterial', id: queryArg.selectableMaterialId},
      ],
      extraOptions: {
        responseSchema: DeleteSelectableMaterialItemResponseSchema,
        requestSchema: DeleteSelectableMaterialItemRequestSchema,
      },
    }),
    pairSelectableMaterialItem: build.mutation<
      PostSelectableMaterialItemPairResponse,
      PostSelectableMaterialItemPairRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}/warehouse-article-links/create`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostSelectableMaterialItemPairResponseSchema,
        requestSchema: PostSelectableMaterialItemPairRequestSchema,
      },
    }),
    unpairSelectableMaterialItem: build.mutation<
      PostSelectableMaterialItemUnpairResponse,
      PostSelectableMaterialItemUnpairRequest
    >({
      query: (queryArg) => ({
        url: `/service/v1/selectable-material/${queryArg.selectableMaterialId}/warehouse-article-links/delete`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostSelectableMaterialItemUnpairResponseSchema,
        requestSchema: PostSelectableMaterialItemUnpairRequestSchema,
      },
    }),
  }),
});
export const {
  useGetSelectableMaterialQuery,
  usePostSelectableMaterialMutation,
  useDeleteSelectableMaterialMutation,
  useGetSelectableMaterialItemQuery,
  usePostSelectableMaterialItemMutation,
  usePatchSelectableMaterialItemMutation,
  useDeleteSelectableMaterialItemMutation,
  usePairSelectableMaterialItemMutation,
  useUnpairSelectableMaterialItemMutation,
} = metadaSelectableMaterial;
